import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { UeCountries } from '../config/StatiMembriDell\'UE'

export default function useCompletedProfile() {
  const [pageOneCompleted, setPageOneCompleted] = useState(false)
  const [pageTwoCompleted, setPageTwoCompleted] = useState(false)
  const [pageThreeCompleted, setPageThreeCompleted] = useState(false)
  const [isCompleted, setIsCompleted] = useState(false)

  const [isCompletedLoading, setIsCompletedLoading] = useState(true)

  const { profile } = useSelector((state) => state.auth)

  useEffect(() => {
    if (profile) {
      if (
        profile.name &&
        profile.lname &&
        profile.email &&
        profile.mobile_number &&
        profile.mobile_number_code &&
        profile.gender &&
        profile.nationality &&
        profile.country_code &&
        profile.birth_date &&
        profile.birth_place
      ) {
        setPageOneCompleted(true)
      }

      if (
        profile.country &&
        profile.province &&
        profile.city &&
        profile.street &&
        profile.building_number &&
        profile.zip_code
      ) {
        setPageTwoCompleted(true)
      }

      if (
        profile.national_id_files.length > 0 &&
        profile.nid_expire_at &&
        profile.serial_number &&
        profile.tax_code_health_card_files.length > 0
      ) {
        if (
          (!UeCountries.includes(profile.nationality) &&
            profile.residence_files.length > 0 &&
            profile.residence_expire_at) ||
          UeCountries.includes(profile.nationality)
        ) {
          setPageThreeCompleted(true)
        }
      }
    }
  }, [profile])

  useEffect(() => {
    if (pageOneCompleted && pageTwoCompleted && pageThreeCompleted) {
      setIsCompleted(true)
    } else {
      setIsCompleted(false)
    }

    setIsCompletedLoading(false)
  }, [pageOneCompleted, pageTwoCompleted, pageThreeCompleted])

  return [
    pageOneCompleted,
    pageTwoCompleted,
    pageThreeCompleted,
    isCompleted,
    isCompletedLoading,
  ]
}
